import { createFileRoute } from '@tanstack/react-router';
import { ComposePane } from '@/features/conversations/ComposePane';

const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export const Route = createFileRoute('/app/conversations/new')({
  component: NewConversationRoute,
  staticData: { title: 'New conversation' },
  validateSearch: (raw: Record<string, unknown>): { location_id?: string } => ({
    location_id: typeof raw.location_id === 'string' && UUID.test(raw.location_id) ? raw.location_id : undefined,
  }),
});

function NewConversationRoute() {
  const { location_id } = Route.useSearch();
  return <ComposePane key={location_id ?? 'none'} locationId={location_id} />;
}
